import { get } from 'lodash';
import { createSelector } from 'reselect';

import { ManageTruckRoutesListEnum } from 'Common/FieldEnum';
import { TruckRouteTypeEnum } from 'Common/Constants/Enumeration/TruckRouteEnum';

const root = state => get(state, 'TruckRouteState.manageTruckRoutesList');

export const getTruckRouteList = state =>
  get(root(state), 'truckRouteListData', []);
export const getTruckRouteListDataLoading = state =>
  get(root(state), 'truckRouteListDataLoading', false);
export const getTruckRouteListDataLoadingError = state =>
  get(root(state), 'truckRouteListDataLoadingError', null);
export const getPrintTruckRouteDetailLoadingError = state =>
  get(root(state), 'printTruckRouteDetailLoadingError', null);
export const getPrintTruckRouteDetailLoading = state =>
  get(root(state), 'printTruckRouteDetailLoading', false);
export const getDeleteTruckRouteSuccess = state =>
  get(root(state), 'deleteTruckRouteSuccess', null);
export const getDeleteTruckRouteLoading = state =>
  get(root(state), 'deleteTruckRouteLoading', false);
export const getDeleteTruckRouteLoadingError = state =>
  get(root(state), 'deleteTruckRouteLoadingError', null);
export const getTruckRouteListWithType = createSelector(
  getTruckRouteList,
  truckRoutes => {
    return truckRoutes.map(truckRoute => ({
      ...truckRoute,
      [ManageTruckRoutesListEnum.Type]:
        truckRoute[ManageTruckRoutesListEnum.Type] === TruckRouteTypeEnum.Pickup
          ? 'Pickup'
          : 'Delivery'
    }));
  }
);



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/managetruckrouteslist/selectors.js